import * as PropTypes from "prop-types";
import * as React from "react";
import { Bling as GPT } from "react-gpt";
import * as Waypoint from "react-waypoint";
import { adBannerSmall, adMobileRectangle, adMobileSquare, adPositions, adSuperzone, adUnits, generateAdTargeting, } from "../../../../shared/utils/ads";
import getResultCategory from "../../utils/getResultCategory";
import removeHTML from "../../utils/removeHTML";
import { AdLabel } from "../ad/adLabel";
import ListItem from "../listItem";
import * as styles from "./styles.css";
var cleanTitle = function (title) { return title.replace(/\s-\sLonely\sPlanet/, ""); };
var getImageUrl = function (str) { return str && str.includes("imgix") ? str : ""; };
var showAd = function (index) { return index > 0 && index % 10 === 0; };
// For places and pois, only use the thumbnail (if available) for more accurate images
var getResultImage = function (type, mainImage, defaultImage) {
    return ["place", "poi"].indexOf(type) >= 0
        ? getImageUrl(mainImage)
        : getImageUrl(mainImage) || getImageUrl(defaultImage);
};
var SearchResults = function (_a) {
    var results = _a.results, onScroll = _a.onScroll;
    return (React.createElement("div", null, results.length && (React.createElement("div", null,
        results.map(function (result, index) {
            var body = result.body, highlights = result.highlights, id = result.id, image = result.image, opType = result.opType, subtype = result.subtype, title = result.title, thumbnail = result.thumbnail, url = result.url;
            var description = highlights.body || removeHTML(body) || "";
            var descriptionPipe = description.indexOf("|");
            var descriptionShort = description.substr(descriptionPipe + 1, descriptionPipe + 251);
            return (React.createElement(React.Fragment, null,
                showAd(index) && (React.createElement("div", { className: styles.adSearchResult },
                    React.createElement(AdLabel, null, "Advertisement"),
                    React.createElement(GPT, { adUnitPath: adUnits.searchInContent, sizeMapping: [
                            {
                                slot: [adMobileRectangle, adMobileSquare, adSuperzone],
                                viewport: [0, 0],
                            },
                            {
                                slot: [adBannerSmall, adSuperzone],
                                viewport: [1390, 0],
                            },
                        ], targeting: generateAdTargeting({
                            position: adPositions.inContent,
                        }) }))),
                React.createElement(ListItem, { className: styles.listItem, key: title + "-" + id, subtype: subtype, category: getResultCategory(result), categoryLink: url, description: descriptionShort, link: url, thumbnail: getResultImage(opType, thumbnail, image), title: cleanTitle(title), type: opType })));
        }),
        React.createElement(Waypoint, { onEnter: onScroll })))));
};
SearchResults.propTypes = {
    onScroll: PropTypes.func,
    results: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string,
        thumbnail: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
        url: PropTypes.string,
    })),
};
export { SearchResults };



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/searchResults/index.tsx
// module id = wdAr
// module chunks = 2